import { Injectable } from '@angular/core';

@Injectable()
export class MenuService {

  public menulist: any[] = [];

  constructor() { }

  getAll() {
    return this.menulist;
    // return [
    //   {
    //     link: '/home',
    //     label: 'Home',
    //     icon: 'apartment',
    //     frmid: 0
    //   },
    //   {
    //     label: 'Students',
    //     icon: 'supervised_user_circle',
    //     link: '/std/stdregister'
    //   },
    //   {
    //     label: 'Fees',
    //     icon: 'monetization_on',
    //     link: '/fee/stdfeedaybook'
    //   },
    //   {
    //     label: 'InOut',
    //     icon: 'store',
    //     link: '/inout/inoutreg'
    //   },
    //   {
    //     label: 'Gate Entry',
    //     icon: 'swap_calls',
    //     link: '/gateentry/gateentryregister'
    //   }, {
    //     label: 'Examination',
    //     icon: 'assignment_turned_in',
    //     items: [
    //       { link: '/po/poform', label: 'Report Card', frmid: 103, icon: 'assignment' },
    //       { link: '/po/poregister', label: 'Report Card Register', frmid: 104, icon: 'list_alt' },
    //     ]
    //   }, {
    //     label: 'Common Master',
    //     icon: 'settings',
    //     items: [
    //       { link: '/pdm/singlevaldialog', label: 'Color1', frmid: 10 },
    //       { link: '/pdm/singlevaldialog', label: 'Sizes1', frmid: 11 },
    //       { link: '/pdm/singlevaldialog', label: 'Brand1', frmid: 12 },
    //       { link: '/pdm/singlevaldialog', label: 'Unit1', frmid: 13 },
    //       { link: '/pdm/singlevaldialog', label: 'Class1', frmid: 14 },
    //       { link: '/pdm/singlevaldialog', label: 'Section1', frmid: 15 },
    //       { link: '/pdm/singlevaldialog', label: 'Subject1', frmid: 16 },
    //       { link: '/pdm/singlevaldialog', label: 'Fee Cat1', frmid: 17 },
    //       { link: '/pdm/itemmasterregister', label: 'Group', frmid: 18 },
    //       { link: '/pdm/itemmasterregister', label: 'Sub Group', frmid: 19 },
    //       { link: '/pdm/itemmasterregister', label: 'Acc Group', frmid: 23 },
    //       { link: '/pdm/itemmasterregister', label: 'Acc Sub Group', frmid: 24 },
    //       { link: '/pdm/itemmasterregister', label: 'Items', frmid: 21 },
    //       { link: '/pdm/itemmasterregister', label: 'Account', frmid: 22 },
    //       { link: '/pdm/itemmasterregister', label: 'Class Subject Master', frmid: 25 },
    //       { link: '/pdm/itemmasterregister', label: 'Teacher', frmid: 27 },
    //       { link: '/pdm/doublevaldialog', label: 'Budget Group', frmid: 28 },
    //     ]
    //   }
    // ];
  }
}
